import {
  BannerTextContainer,
  Container,
  TextContainer,
} from 'components/credits/credit-details/CreditItemDetailsBanner/components';

import { Articulation } from 'types/articulation';
import BannerContainer from 'components/layout/BannerContainer';
import BannerText from 'components/layout/BannerText';
import BannerTitle from 'components/layout/BannerTitle';
import { CreditItemDetailsButtonContainer } from 'components/credits/credit-details/CreditItemDetailsButtonContainer';
import { CreditType } from 'types/credit';
import { Precedent } from 'types/precedent';
import { Spin } from 'antd';
import { getTotalCreditPoints as getArticulationCP } from 'utils/articulation';
import { getTotalCreditPoints as getPrecedentCP } from 'utils/precedent';
import { useMemo } from 'react';
import useTranslation from 'hooks/use-translation';

type Props =
  | { creditType: CreditType.ARTICULATION; articulation: Articulation }
  | { creditType: CreditType.PRECEDENT; precedent: Precedent };

export function CreditItemDetailsBanner(props: Props): JSX.Element {
  const translation = useTranslation();
  const creditPoints = useMemo(
    () =>
      props.creditType === CreditType.ARTICULATION
        ? getArticulationCP(props.articulation)
        : getPrecedentCP(props.precedent),
    [props],
  );
  const creditItemID = props.creditType === CreditType.ARTICULATION ? props.articulation.ID : props.precedent.ID;

  if (!translation) {
    return <Spin />;
  }

  return (
    <BannerContainer className='banner-container'>
      <Container className='credit-details-banner-container'>
        <div className='credit-details-banner-button-container'>
          <CreditItemDetailsButtonContainer creditItemID={creditItemID} creditType={props.creditType} />
        </div>
        <BannerTitle className='banner-title'>Credit Detail</BannerTitle>
        <TextContainer>
          <BannerTextContainer className='credit-points-banner-text-container'>
            <BannerText className='credit-points-you-may-receive'>You may receive</BannerText>
            <BannerText className='credit-points-space'>&nbsp;</BannerText>
            <BannerText className='credit-points-x-credit-points'>{creditPoints} credit points</BannerText>
          </BannerTextContainer>
          <BannerText className='banner-description'>{translation.details.description}</BannerText>
        </TextContainer>
      </Container>
    </BannerContainer>
  );
}
